import React, { createContext, useContext, useReducer } from "react";

const BulkSelectionContext = createContext();

const initialState = {
  isSelectionMode: false,
  selectedTickets: [],
  selectAll: false,
};

const bulkSelectionReducer = (state, action) => {
  switch (action.type) {
    case "TOGGLE_SELECTION_MODE":
      return {
        ...state,
        isSelectionMode: !state.isSelectionMode,
        selectedTickets: !state.isSelectionMode ? [] : state.selectedTickets,
      };

    case "ENABLE_SELECTION_MODE":
      return {
        ...state,
        isSelectionMode: true,
      };

    case "DISABLE_SELECTION_MODE":
      return {
        ...state,
        isSelectionMode: false,
        selectedTickets: [],
        selectAll: false,
      };

    case "SELECT_TICKET":
      const ticketExists = state.selectedTickets.find(
        (ticket) => ticket.id === action.payload.id
      );
      
      if (ticketExists) {
        return {
          ...state,
          selectedTickets: state.selectedTickets.filter(
            (ticket) => ticket.id !== action.payload.id
          ),
          selectAll: false,
        };
      } else {
        return {
          ...state,
          selectedTickets: [...state.selectedTickets, action.payload],
        };
      }

    case "SELECT_ALL_TICKETS":
      return {
        ...state,
        selectedTickets: action.payload,
        selectAll: true,
      };

    case "DESELECT_ALL_TICKETS":
      return {
        ...state,
        selectedTickets: [],
        selectAll: false,
      };

    case "CLEAR_SELECTION":
      return {
        ...state,
        selectedTickets: [],
        selectAll: false,
      };

    default:
      return state;
  }
};

export const BulkSelectionProvider = ({ children }) => {
  const [state, dispatch] = useReducer(bulkSelectionReducer, initialState);

  const toggleSelectionMode = () => {
    dispatch({ type: "TOGGLE_SELECTION_MODE" });
  };

  const enableSelectionMode = () => {
    dispatch({ type: "ENABLE_SELECTION_MODE" });
  };

  const disableSelectionMode = () => {
    dispatch({ type: "DISABLE_SELECTION_MODE" });
  };

  const selectTicket = (ticket) => {
    dispatch({ type: "SELECT_TICKET", payload: ticket });
  };

  const selectAllTickets = (tickets) => {
    dispatch({ type: "SELECT_ALL_TICKETS", payload: tickets });
  };

  const deselectAllTickets = () => {
    dispatch({ type: "DESELECT_ALL_TICKETS" });
  };

  const clearSelection = () => {
    dispatch({ type: "CLEAR_SELECTION" });
  };

  const isTicketSelected = (ticketId) => {
    return state.selectedTickets.some((ticket) => ticket.id === ticketId);
  };

  const value = {
    ...state,
    toggleSelectionMode,
    enableSelectionMode,
    disableSelectionMode,
    selectTicket,
    selectAllTickets,
    deselectAllTickets,
    clearSelection,
    isTicketSelected,
  };

  return (
    <BulkSelectionContext.Provider value={value}>
      {children}
    </BulkSelectionContext.Provider>
  );
};

export const useBulkSelection = () => {
  const context = useContext(BulkSelectionContext);
  if (!context) {
    throw new Error("useBulkSelection must be used within a BulkSelectionProvider");
  }
  return context;
}; 